import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  PERMISSIONS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { buildUrl, prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

export enum UserProfileType {
  CUSTOM = 'Custom',
  STANDARD = 'Standard',
}

export interface AssignableUserProfile {
  userProfileId: string;
  name: string;
  tenantId: string;
  roleIds: string[];
  profileIds: string[];
  cumulDashboardIds: string[];
  permissions: PERMISSIONS[];
  userProfileType: UserProfileType;
}

const ENDPOINT = `${APIConfiguration.authorization}users/listUserProfile`;

export interface ListUserProfileQueryPayload {
  tenantId: string;
}

export const listUserProfileQuery = async ({
  tenantId,
}: ListUserProfileQueryPayload): Promise<
  BackResponse<AssignableUserProfile[]> | BackResponseFailure
> => {
  try {
    const response = await apiCall<BackResponse<AssignableUserProfile[]>>(
      buildUrl(ENDPOINT, { tenantId }),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
